/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Contributions_ManyInputs */

const en_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} contributions`)
};

const ar_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} مساهمة`)
};

const bn_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}টি কন্ট্রিবিউশন`)
};

const de_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Beiträge`)
};

const es_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} contribuciones`)
};

const fr_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} contributions`)
};

const pt_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} contribuições`)
};

const zh_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次贡献`)
};

const tr_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} katkı`)
};

const ru_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} вкладов`)
};

const pl_contributions_many = /** @type {(inputs: Contributions_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kontrybucji`)
};

/**
* | output |
* | --- |
* | "{count} contributions" |
*
* @param {Contributions_ManyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contributions_many = /** @type {((inputs: Contributions_ManyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contributions_ManyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contributions_many(inputs)
	if (locale === "bn") return bn_contributions_many(inputs)
	if (locale === "de") return de_contributions_many(inputs)
	if (locale === "es") return es_contributions_many(inputs)
	if (locale === "fr") return fr_contributions_many(inputs)
	if (locale === "pt") return pt_contributions_many(inputs)
	if (locale === "zh") return zh_contributions_many(inputs)
	if (locale === "tr") return tr_contributions_many(inputs)
	if (locale === "ru") return ru_contributions_many(inputs)
	if (locale === "pl") return pl_contributions_many(inputs)
	return en_contributions_many(inputs)
});